import queryString from 'query-string'
import React, { useEffect } from 'react'
import ReactHtmlParser from 'react-html-parser'
import { useDispatch, useSelector } from 'react-redux'
import { SvgIcon } from '../../../../../components'
import Button from '../../../../../components/Button'
import { useAlertModal } from '../../../../../legacy/components/AlertModal'
import { getProductOriginURL } from '../../../../../utils/config'
import { handleDowelingOrder } from '../../../common/handleOrders'
import useJobEditor from '../../../common/useJobEditor'
import useStaticData from '../../../common/useStaticData'
import { ModelImageList, RelatedImageList, handleRelatedProductClick } from '../../../components'
import TableView from '../../../components/TableView'

const DowelingOutput = () => {
  const dispatch = useDispatch()
  const { input, output, status } = useSelector((state) => state.calculation)
  const staticData = useSelector((state) => state.staticData)
  const { adhesiveAnchor, insertType, source } = input
  const { updateJobIndex, mobileViewOrderCounter } = status
  const params = window.location.search ? queryString.parse(window.location.search) : {}

  const [deleteAlertModalProps, DeleteAlertModal] = useAlertModal()

  const jobTableSize = output.jobs ? output.jobs.length : 0
  const { getModels, getProductImage, getProductImages, getProductInfo } = useStaticData(staticData)
  const models = getModels(adhesiveAnchor)
  const productInfo = getProductInfo(adhesiveAnchor)
  const relatedImageItems = [insertType, 'Drill Bits', 'Accessories'].concat(
    productInfo.resinType === 'Epoxy'
      ? ['EpoxyMixingNozzles', 'EpoxyDispensingTools']
      : ['AcrylicMixingNozzles', 'AcrylicDispensingTools'],
  )

  const modelImages = getProductImages(models.map((item) => item.model))
  const relatedImages = getProductImages(relatedImageItems)

  const handleJobAddClick = () => {
    const jobs = [...output.jobs]
    const newJob = Object.assign({}, jobs[updateJobIndex])
    newJob.jobName = 'Job ' + (jobs.length + 1)

    dispatch({ type: 'JOB_ADD', payload: newJob })
  }

  const myFooterProps = (column) => {
    return column.id === 'Action' ? { colSpan: '2' } : {}
  }

  const rowEditProps = (row) => {
    return row.index === updateJobIndex
      ? {
          className: 'active',
        }
      : {}
  }

  useEffect(() => {
    if (jobTableSize === updateJobIndex + 1) {
      if (document.getElementsByClassName('scrollable').length > 0) {
        const scrollableElement = document.getElementsByClassName('scrollable')[0]
        scrollableElement.scrollTop = scrollableElement.scrollHeight
      }
    }
  }, [updateJobIndex])

  useEffect(() => {
    if (mobileViewOrderCounter >= 0) {
      handleDowelingOrder(output, input)
    }
  }, [mobileViewOrderCounter])

  const { getJobColumns, handleFooterSubmitClick, updateMyData } = useJobEditor(
    output,
    input,
    deleteAlertModalProps,
    updateJobIndex,
  )
  const jobColumns = getJobColumns(models, output.jobs)
  const productImage = getProductImage(adhesiveAnchor)

  return (
    <>
      <DeleteAlertModal
        headerText={'Delete Job?'}
        bodyText={'Are you sure you want to delete this job? This action cannot be undone.'}
        cancelButtonText={'Cancel'}
        submitButtonText={'Delete Job'}
        handleSubmitClick={handleFooterSubmitClick}
      />

      <section id="aceTallyOutput">
        {output.jobs && output.jobs.length > 0 ? (
          <TableView
            title={'Job Tally'}
            columns={jobColumns}
            data={output.jobs}
            getRowProps={rowEditProps}
            getFooterProps={myFooterProps}
            updateMyData={updateMyData}
            showFooter={true}
          />
        ) : null}


        <Button variant="primary" onClick={handleJobAddClick}>
          <SvgIcon src="assets/images/iconic/plus-thin.svg" />
          <span className="button__text">Add New Job</span>
        </Button>
      </section>

      <section id="aceProductOutput" className="aceProductOutput">
        <a
          className="adhesiveMainProductLink"
          href={
            params && params.source === 'EC'
              ? productImage.productUrlEC && `${getProductOriginURL()}/${productImage.productUrlEC}`
              : productImage.productUrl
          }
          target="_blank"
          onMouseDown={() =>
            handleRelatedProductClick({
              adhesiveAnchor,
              productInfo,
              source,
              isAdhesiveMainProductLink: true,
            })
          }
          rel="noreferrer"
        >
          {adhesiveAnchor}
          &nbsp;<span className="productSummary">{productInfo.shortDesc}</span>
        </a>

        <div>
          <ModelImageList modelImages={modelImages} />
          <p>{ReactHtmlParser(productInfo.blurb)}</p>
        </div>

        <section id="aceDowelingOutputRelatedProducts">
          <h4>Related Products</h4>
          <div>
            <RelatedImageList
              source={source}
              relatedImages={relatedImages}
              insertType={insertType}
              adhesiveAnchor={adhesiveAnchor}
            />
          </div>
        </section>

        {source === 'EC' ? (
          <div className="aceProductOutput__orderButtonWrapper">
            <Button variant="primary" onClick={() => handleDowelingOrder(output, input)}>
              <span className="button__text">Order</span>
              <span className="material-icons">chevron_right</span>
            </Button>
          </div>
        ) : null}
      </section>
    </>
  )
}

export default DowelingOutput
